module.exports = __webpack_public_path__ + "img/banner_es.e4743968.jpg";